import Vue from 'vue'

export const participant = Vue.observable({
    title :"", 
    participantType : undefined,
    cnp : "",
    cuim : "",
    cuibbc : "",
    didactic : "",
    name : "",
    surname : "",
    institution: "",
    specialisation : "",
    department :"",
    country : "Romania",
    selectedCounty : undefined,
    county : "",
    city : "",
    officePhone :"",
    mobile : "",
    email : "",
    password:"",
    confirmPassword:"",
    useDataTerms :false,
    sendDataTerms:true,
    useForCongresAndInfo : false,
    services : {
        participationType : undefined,
        sponsored: false,
        sponsoredBy : "",
        sponsoredDetails : "",
        selectedServices : []
    },
        rooms :{
            roomNote : "",
            roomSponsor : "",
            selectedRooms : []
        },
    resumes : [],
    payments : [],
    generalConditions : false
});

export const resetParticipant = Vue.observable({
    title :"", 
    participantType : undefined,
    cnp : "",
    cuim : "",
    cuibbc : "",
    didactic : "",
    name : "",
    surname : "",
    institution: "",
    specialisation : "",
    department :"",
    country : "Romania",
    selectedCounty : undefined,
    county : "",
    city : "",
    officePhone :"",
    mobile : "",
    email : "",
    password:"",
    confirmPassword:"",
    useDataTerms :false,
    sendDataTerms:true,
    useForCongresAndInfo : false,
    services : {
        participationType : undefined,
        sponsored: false,
        sponsoredBy : "",
        sponsoredDetails : "",
        selectedServices : []
    },
        rooms :{
            roomNote : "",
            roomSponsor : "",
            selectedRooms : []
        },
    resumes : [],
    payments : [],
    generalConditions : false
});

// export const participant = Vue.observable({
//     title :"Doamna",
//     selectedParticipantType : undefined,
//     participantType : 6,
//     cnp : "1111111111111",
//     cuim : "1111111111",
//     cnpOrCui : undefined,
//     didactic : "1",
//     name : "1",
//     surname : "1",
//     institution: "1",
//     specialisation : "1",
//     department :"1",
//     country : "Romania",
//     selectedCounty : "Romania",
//     county : "ALBA",
//     officePhone :"0755137228",
//     mobile : "0755137228",
//     email : "danutzul_05@hhds.com",
//     password:"111111",
//     confirmPassword:"111111",
//     useDataTerms :true,
//     sendDataTerms:true,
//     services : {
//         participationType : undefined,
//         taxFirma : "",
//         taxNote : "",
//         selectedServices : []
//     },
//     rooms :{
//         roomNote : "",
//         roomSponsor : "",
//         selectedRooms : []
//     },
//     resumes : [],
//     payments : [],
//     generalConditions : false
// });
